import { NavigationController } from "../../components/NavigationController/NavigationController"
import { MultiStepProvider } from "../../context/multiStepContext"
import { PurchasProvider } from "../../context/purchaseContext"
import {
  UltimateAlertsContext,
  UltimateAlertsProvider,
} from "../../context/ultimateAlertsContext"
import ConditionalFreeTrialPaywall from "../ConditionalFreeTrialPaywall/ConditionalFreeTrialPaywall"
import FreeDaysPaywallStep from "./FreeDaysPaywallStep/FreeDaysPaywallStep"
import LockPicturesPaywallStep from "./LockPicturesPaywallStep/LockPicturesPaywallStep"
import PurchasePaywallSheet from "./PurchasePaywallStep/PurchasePaywallSheet/PurchasePaywallSheet"
import PurchasePaywallStep from "./PurchasePaywallStep/PurchasePaywallStep"
import ReminderPaywallStep from "./ReminderPaywallStep/ReminderPaywallStep"

const MultiStepPaywall = () => {
  return (
    <PurchasProvider>
      <UltimateAlertsProvider>
        <MultiStepProvider>
          <ConditionalFreeTrialPaywall freeTrialPaywall={NavigationPaywall} />
        </MultiStepProvider>
      </UltimateAlertsProvider>
    </PurchasProvider>
  )
}

const NavigationPaywall = () => {
  return (
    <>
      <PurchasePaywallSheet />
      <NavigationController
        screens={[
          <LockPicturesPaywallStep />,
          <FreeDaysPaywallStep />,
          <ReminderPaywallStep />,
          <PurchasePaywallStep />,
        ]}
      />
    </>
  )
}

export default MultiStepPaywall
